import CompanyRoutes from '../../apiRoutes/CompanyRoutes';
import { api } from '../ConsumeApiController';

export async function getAllAssets() {
    const route = CompanyRoutes.Assets.getAll;
    const response = await api.get(route);
    if(response.success === true)
    {
        return {
            success:true,
            assets: response.data,
            message: response.message
        }
    }
    else
    {
        return {
            success: false,
            assets: [],
            message: response.message
        }
    }
}

export async function createAsset(data) {
    const route = CompanyRoutes.Assets.create;
    return await api.post(route, data);
}

export async function updateAsset(id, data) {
    const route = CompanyRoutes.Assets.update(id);
    return await api.put(route, data);
}

export async function deleteAsset(id) {
    const route = CompanyRoutes.Assets.delete(id);
    return await api.delete(route);
}